// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEligibleDependentsDto
 */
export interface IEligibleDependentsDto {
    /**
     * 
     * @type {number}
     * @memberof IEligibleDependentsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEligibleDependentsDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEligibleDependentsDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IEligibleDependentsDto interface.
 */
export function instanceOfIEligibleDependentsDto(value: object): value is IEligibleDependentsDto {
    return true;
}

export function IEligibleDependentsDtoFromJSON(json: any): IEligibleDependentsDto {
    return IEligibleDependentsDtoFromJSONTyped(json, false);
}

export function IEligibleDependentsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEligibleDependentsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IEligibleDependentsDtoToJSON(json: any): IEligibleDependentsDto {
    return IEligibleDependentsDtoToJSONTyped(json, false);
}

export function IEligibleDependentsDtoToJSONTyped(value?: IEligibleDependentsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

